<template>
    <div class="flex w-full overflow-hidden rounded-[12px]">
        <img
            :src="`${staticUrl}/assets/img/promotions/8-percent/bti-risk-free.jpg`"
            alt="bti-risk-free"
            class="flex w-full object-cover"
            @click="handleSportClick(bti)"
        />
    </div>
</template>
<script setup>
import { useAlertStore, useModalStore, useUserStore } from '~/stores'
const staticUrl = useRuntimeConfig().public.staticUrl
const alertStore = useAlertStore()
const { t } = useI18n({})
const localePath = useLocalePath()
const useUserStoreInstance = useUserStore()
const useModalStoreInstance = useModalStore()

const { isMobile } = useDevice()
const bti = ref({
    id: 'bti',
    key: 'bti',
    title: 'bti',
    api_url: '/gameUrl?partnerProvider=bti',
    page_url: '/btisports',
    logo: '/assets/icons/casino/provider/a-sport.svg',
    image: '/assets/img/sports/sportbook/bti-card.png',
    imageMobile: '/assets/img/sports/sportbook/bti-mb.png',
    imageLable: '/assets/img/sports/sportbook/sport.png',
    require_auth: true,
})

const headers = useRequestHeaders(['cookie'])
const handleSportClick = async (item = {}) => {
    // check auth
    if (item.require_auth && !useUserStoreInstance.isLoggedIn) {
        useModalStoreInstance.showLoginModal = true
        return
    }
    // if desktop rout to page
    if (!isMobile) {
        navigateTo(localePath(item.page_url))
        return
    }
    // if mobile get url from api, open new tab
    try {
        const newtab = window.open('', '_blank')
        const { data } = await useFetch(item.api_url, {
            headers,
            baseURL: '/api/v1',
        })
        if (data.value.status === 'OK') {
            const { url } = data.value.data
            if (newtab) newtab.location.href = url
            // setTimeout(() => {
            //     const popup = window.open(url, '_blank')
            //     if (!popup) {
            //         alertStore.showMessageError({
            //             value: {
            //                 statusCode: 'SHOW_MESSAGE',
            //                 message: t('error.allow_popup'),
            //             },
            //         })
            //         window.open(url, '_blank')
            //     }
            // })
        } else {
            if (newtab) newtab.close()
            alertStore.showMessageError({
                value: {
                    statusCode: 'SHOW_MESSAGE',
                    message: t('error.server_is_busy'),
                },
            })
        }
    } catch (error) {
        if (newtab) newtab.close()
        console.error(error)
    }
}
</script>
